module.exports = __webpack_public_path__ + "media/home-video-sm.a000a646.mp4";